import React from 'react';
import {
  TableOrders,
  API,
  withRouter,
} from 'vibeguide';
import SubNavigation from '../../Header/SubNavigation';

function OrderList() {
  return (
    <div
      className="OrderList"
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <SubNavigation
        title="Orders"
      />

      <TableOrders
        columns={[
          'Name',
          'Status',
          'Opportunity Name',
          'Opportunity ID',
          'Delivery System',
          'Ad Provider',
          'Media Format',
          'Flight Stage',
          'Start Date',
          'End Date',
          'Modified Date',
          'Created Date',
          'Created By',
          '...',
        ]}
        fetch={API.Order.list}
        defaultSortBy={{
          label: 'Name',
          attr: 'name',
          direction: 'asc',
        }}
        paginator
        paginatorProps={{
          label: 'Orders',
          urlPaging: true,
          urlFilters: true,
        }}
        rowLink="/ad-ops/order/{_id}/details"
        menuItems={[
          {
            name: 'Copy',
            userCan: 'flight.create',
          },
          {
            name: 'Pause',
            // Allow pause if the user has permission
            userCan: 'order.pause',
            disabled: (row) => {
              return row.status !== 'live';
            },
          },
          {
            name: 'Resume',
            // Allow resume if the user has permission (currently no order.resume permission)
            userCan: 'order.pause',
            disabled: (row) => {
              return row.status !== 'paused';
            },
          },
          {
            name: 'Cancel',
            userCan: 'order.cancel',
            disabled: (row) => {
              return row.status === 'cancelled' || row.status === 'completed';
            },
          },
        ]}
      />
    </div>
  );
}

export default withRouter(OrderList);
